import styled, { css } from 'styled-components';

/** In UA2 the page is white like the UA2 panel around it, so white blocks get a thin border instead (ZennoProxy). */
export const embeddedCard = css`
  html[data-embedded='true'] & {
    border: 1px solid ${p => p.theme.color.Neutral30};
  }
`;

/** Scroll container standalone (the kit's GlobalStyles lock body scrolling); in UA2 the page scrolls instead. */
export const Page = styled.main`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 20px;
  flex: 1;
  min-width: 0;
  height: 100%;
  overflow: auto;
  background: ${p => p.theme.color.Neutral10};

  /* In UA2: content height (the page scrolls), white like the UA2 panel, no side padding of its own. */
  html[data-embedded='true'] & {
    height: auto;
    overflow: visible;
    padding: 0 0 20px;
    background: ${p => p.theme.color.Neutral0};
  }
`;

/** White block of a page section (pfm/UA2 style). */
export const Panel = styled.section`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 20px;
  border-radius: 8px;
  background: ${p => p.theme.color.Neutral0};

  /* In UA2 the page is the panel: no frame inside the content. */
  html[data-embedded='true'] & {
    padding: 0;
    border-radius: 0;
  }
`;

export const PageHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;

  /* In UA2 the title is hidden and the actions start at the left edge, under the UA2 tabs. */
  html[data-embedded='true'] & {
    justify-content: flex-start;
  }
`;

/** The page title; in UA2 its tab already names the section. */
export const PageTitle = styled.h1`
  margin: 0;
  font-size: 20px;
  font-weight: 600;
  color: ${p => p.theme.color.Neutral100};

  html[data-embedded='true'] & {
    display: none;
  }
`;

export const Centered = styled.div`
  min-height: 60vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  padding: 24px;
  text-align: center;
  flex: 1;
`;

export const Toolbar = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
`;

/** Form actions stay in view at the bottom of the scroll container. */
export const ActionBar = styled.div`
  position: sticky;
  bottom: -20px;
  /* Above antd controls that lift themselves (the checked radio button has z-index 1). */
  z-index: 10;
  margin: 0 -20px -20px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 16px 20px;

  html[data-embedded='true'] & {
    margin: 0 0 -20px;
    padding: 16px 0;
  }
  background: ${p => p.theme.color.Neutral0};
  border-top: 1px solid ${p => p.theme.color.Neutral30};
  box-shadow: 0 -4px 12px rgba(0, 0, 0, 0.04);

  /* A captioned field next to buttons: caption above, control on the buttons' line. */
  ${Toolbar} {
    align-items: flex-end;
  }

  label:not([class*='ant-']) {
    display: flex;
    flex-direction: column;
    gap: 6px;
    color: ${p => p.theme.color.Neutral80};
  }
`;
